import styled from 'styled-components';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { reemaColors } from 'toolkit/styles/colors';

import { Button } from '@act/storybook';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface ConfirmDeleteDialogProps {
  handleClose: () => void;
  deleteHandler: () => void;
  open: boolean;
  subject: string;
}

const MightyIcon = styled.div`
  font-size: 75px;
  text-align: center;
  margin-bottom: 16px;
  .icon-container {
    margin: 0 auto;
    font-size: 75px;
    text-align: center;
    background: rebeccapurple;
    display: flex;
    border-radius: 50%;
    height: 85px;
    width: 85px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  svg {
    font-size: 75px;
  }
  &.alert {
    .icon-container {
      color: ${reemaColors.warning};
      background: ${reemaColors.warningLight};
    }
  }
`;

const ConfirmDeleteDialog = ({
  open,
  handleClose,
  deleteHandler,
  subject,
}: ConfirmDeleteDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete {subject}</DialogTitle>
      <DialogContent dividers>
        <MightyIcon className="mighty-icon alert">
          <div className="icon-container">
            <ErrorOutlineIcon fontSize="large" />
          </div>
        </MightyIcon>

        <DialogContentText id="dialog-content" sx={{ textAlign: 'center' }}>
          Are you sure you want to delete this {subject}?
          <Typography variant="bodyMedium" gutterBottom>
            This item will no longer be available.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button trackingName="close-button" onClick={handleClose}>Cancel</Button>
        <Button trackingName="delete-handler-button"
          variant="contained"
          color="error"
          debounced
          onClick={deleteHandler}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
